<template>
  <AppSection top>
    <AppContainer>
      <h1 v-html="$tt('contact_page.header')" class="mb-8" />
      <AppThirdLayout>
        <AppImg src="/images/superman-with-headphones-n-mic.jpg" alt="Superman" />
        <div>
          <p class="content lead me-10">{{ $tt('contact_page.assist') }}</p>
          <div class="flex gap-3 mt-7 mb-5">
            <AppIcon icon="mingcute:hours-line" color="tertiary" size="x-large" />
            <h2>{{ $tt('contact_page.support_247') }}</h2>
          </div>
          <div class="links-wrapper flex wrap mb-7">
            <AppBtn @click="openChatboxBus.emit" block>
              <AppIcon icon="bx:chat" color="primary" start />
              {{ $tt('contact_page.chat') }}
            </AppBtn>
            <SupportEmailLink>
              <AppBtn block>
                <AppIcon icon="clarity:email-line" color="primary" start />
                {{ $tt('contact_page.email') }}
              </AppBtn>
            </SupportEmailLink>
          </div>
          <div class="flex gap-3 mb-2">
            <AppIcon icon="fluent:person-support-24-filled" color="tertiary" size="x-large" />
            <div class="mb-5">
              <h2 class="mb-1">{{ $tt('contact_page.additional_support') }}</h2>
              <p>{{ $tt('contact_page.availability') }}</p>
            </div>
          </div>
          <div class="links-wrapper flex wrap mb-7">
            <PhoneLink>
              <AppBtn block>
                <AppIcon icon="uil:phone" color="primary" start />
                {{ phone.display }}
              </AppBtn>
            </PhoneLink>
            <WhatsappLink>
              <AppBtn block>
                <AppIcon icon="mdi:whatsapp" color="primary" start />
                {{ $tt('whatsapp') }}
              </AppBtn>
            </WhatsappLink>
            <a v-if="telegram" :href="telegram" target="_blank">
              <AppBtn block>
                <AppIcon icon="uil:telegram-alt" color="primary" start />
                {{ $tt('socials.telegram') }}
              </AppBtn>
            </a>
          </div>
          <ContactForm />
        </div>
      </AppThirdLayout>
    </AppContainer>

    <ChatWidget />
  </AppSection>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';

const { phone, telegram } = useCommunication();
const { openChatboxBus } = useEmitter();
const { tt } = useLocalization();

usePageHead({
  title: tt('contact_page.title', { year: getCurrentYear() }),
  description: tt('contact_page.meta_desc'),
  alternateBranches: 'all',
});
useSchemaOrg('contact');
</script>

<style scoped>
p {
  line-height: var(--lh-md);
}
img {
  width: 100%;
}
.links-wrapper {
  gap: var(--space-5) var(--space-7);
}
.links-wrapper > * {
  flex-basis: calc(50% - calc(var(--space-7) / 2));
  box-sizing: border-box;
}
h2 {
  font-size: 24px;
}

@media (max-width: 850px) {
  h1 {
    margin-bottom: var(--space-3) !important;
    font-size: 30px;
    text-align: center;
  }
  h2 {
    font-size: 20px;
  }
  .lead {
    font-size: 16px;
  }
  .content {
    font-size: 20px;
  }
  h2, .content {
    text-align: center;
    margin-inline-end: 0 !important;
  }
  .links-wrapper > * {
    flex-basis: 100%;
  }
}
</style>